import React, { useCallback, useState } from "react";
import { Stack } from "@mui/material";
import { Input, Message, Typography } from "..";
var onSubmit = function (rawValue, total, onChange) {
    var value = +rawValue;
    if (rawValue === "")
        return;
    if (isNaN(value) || value < 1 || value > total) {
        Message.warning("请输入有效页数");
    }
    else {
        onChange(value);
    }
};
function GoToPage(_a) {
    var total = _a.total, onChange = _a.onChange;
    var _b = useState(null), page = _b[0], setPage = _b[1];
    var handleChange = useCallback(function (e) {
        var value = e.currentTarget.value;
        setPage(value);
    }, []);
    var handleBlur = useCallback(function () {
        if (page == null)
            return;
        onSubmit(page, total, onChange);
    }, [page, total, onChange]);
    var handleKeyDown = useCallback(function (e) {
        if (e.keyCode !== 13 || page == null)
            return;
        onSubmit(page, total, onChange);
    }, [page, total, onChange]);
    return (React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", flexShrink: 0 },
        React.createElement(Typography, { variant: "body2" }, "\u8DF3\u81F3"),
        React.createElement(Input, { type: "number", size: "small", sx: { width: 60 }, onChange: handleChange, onBlur: handleBlur, onKeyDown: handleKeyDown }),
        React.createElement(Typography, { variant: "body2" }, "\u9875")));
}
export default GoToPage;
